import { General } from '../types/data/general.d';

const general: General = {
    name: {
        origin: 'Evelyn',
        alias: 'Epel',
    },
    debut: 'January 13, 2019',
    birthday: 'December 1',
    height: {
        origin: '160 cm',
        withAhoge: '165 cm',
    },
    weight: '52 kg',
    blood: 'B+',
    zodiac: 'Sagittarius',
    affilation: {
        current: 'Independent',
        formerly: 'Re:Memories',
    },
    languages: ['Indonesian', 'English', 'Little bit of Japanese'],
};

export default general;
